(function ($) {
    function toCapitalize(text) {
        text = text.toLowerCase().charAt(0).toUpperCase() + text.toLowerCase().slice(1);
        return text;
    }

    const posted_successfully = $('#posted_successfully').length;
    if (posted_successfully > 0) {
        notif(1, 'You have successfully subscribed to the newsletter!');
        $('.subscribe-body-right form').append(`
            <input type="hidden" name="contact[tags]" value="newsletter">
            <input type="email" name="contact[email]" class="Form__Input" aria-label="Email address"
                placeholder="ENTER YOUR EMAIL HERE" required>
            <button type="submit" class="Form__Submit Button Button--primary">
                <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/Vector_2.svg?v=1725264453">
            </button>    
        `)
    }

    if(window.location.pathname.includes('/challenge')) {
        $(window).scrollTop(0, 0);
        // console.log('tes', $(window).scrollTop());
        let ivtx;
        ivtx = setInterval(() => {
            clearInterval(ivtx);
            $(window).scrollTop(0, 0);
        }, 100);
    }

    $(document).on('click', '#contact-form .Form__Submit', function (e) {
        e.preventDefault();
        const btn_subscribe = $('#quickbuy-modal .subscribe-newsletter-btn');
        $('#quickbuy-modal').toggleClass('show');
        $('#quickbuy-content').addClass('quickbuy-newsletter')
        $('#quickbuy-content').append(`<div class="quickbuy-modal-newsletter">
            <div class="quickbuy-modal-newsletter-content">
                <h3>Are you sure want to subscribe to our newsletter?</h3>
                <div class="row">
                    <div class="small-12 medium-6 columns">
                        <button type="button" class="btn btn--primary subscribe-newsletter-btn" aria-has-subscribe="true">Subscribe</button>
                    </div>
                    <div class="small-12 medium-6 columns">
                        <button type="button" class="btn btn--primary cancel-newsletter-btn" aria-has-subscribe="false">Cancel</button>
                    </div>      
                </div>
            </div>
        </div>`);

        $(document).on('click', '.quickbuy-modal-newsletter .subscribe-newsletter-btn', function (e) {
            // console.log($(this).attr('aria-has-subscribe'));
            if ($(this).attr('aria-has-subscribe') == 'true') {
                $.ajax({
                    url: '/contact#contact-form',
                    type: 'POST',
                    data: $(this).closest('.Form').serialize(),
                    success: function (response) {
                        // console.log(response)
                        notif(1, 'You have successfully subscribed to the newsletter!');
                        $('#quickbuy-modal').removeClass('show');
                        $('#quickbuy-content').find('.quickbuy-modal-newsletter').remove();
                        $('.subscribe-body-right form .Form__Input').val('');
                        
                    }, 
                    error: function (error, response) {
                        if (error.status == 429) {
                            $('#contact-form').trigger('submit');
                        }
                        // notif(0, 'Something went wrong, please try again later!');
                    }
                });
            }
        });

        $(document).on('click', '.quickbuy-modal-newsletter .cancel-newsletter-btn', function (e) {
            // console.log($(this).attr('aria-has-subscribe'));
            if ($(this).attr('aria-has-subscribe') == 'false') {
                $('#quickbuy-modal').removeClass('show');
                $('#quickbuy-content').find('.quickbuy-modal-newsletter').remove();
                $('#quickbuy-content').removeClass('quickbuy-newsletter');
            }
        });
    });

    $(document).on('click', '.quickbuy-newsletter .btn-close', function (e) {
        e.preventDefault();
        $('#quickbuy-modal').removeClass('show');
        $('#quickbuy-content').find('.quickbuy-modal-newsletter').remove();
        $('#quickbuy-content').removeClass('quickbuy-newsletter');
    });

    document.addEventListener("DOMContentLoaded", function () {
        const header = document.getElementById("shopify-section-header-2024");
    
        window.addEventListener("scroll", function () {
            if (window.scrollY > 50) {
                header.classList.add("header-has-scrolled");
            } else {
                header.classList.remove("header-has-scrolled");
            }
        });
    });
    
    function truncateWords(str, wordLimit) {
        const words = str.split(" ");
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(" ") + "..."
            : str;
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function convertToSlug(Text) {
        return Text.toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");
    }

    function notif(status = 1, message) {
        let alert = 'Alert--success'
        if (status != 1) {
            alert = 'Alert--error'
        }

        var t = document.createElement("span");
        t.className = `Alert ${alert} all-notif`, t.innerHTML = message;

        $("body").prepend(t)
        setTimeout(() => {
            t.className += " active";
        }, 200);
        setTimeout(function () {
            t.classList.remove("active");
            setTimeout(() => {
                t.remove()
            }, 500);
        }, 2700)
    }

    $('#mega-menu-sale-anchor').click(function () {
        let megamenu = $(this).closest('.menu.menu-desk').find('.menu-item.menu-sale').find('.MegaMenu.sale')
        $(megamenu).addClass('show--mega-menu')
    })

    $('#search-button').click(function () {
        // filter collection
        
        if ($('#close-container-drawer').attr('aria-sidebar') == 'closed') {
            $('#close-container-drawer').attr('aria-sidebar', 'opened')
            $('body').css('overflow', 'hidden').addClass("menu-opened")
            let check_filter = $('.collection-sidebar-panel.hide-mobile') 
            if (!check_filter.hasClass('active')) {
                
            } else {
                $('.filter-toggle').trigger('click');
                $('#close-container-drawer-filter').attr('aria-sidebar', 'closed')
            }
            $('#atmos-sidebar').attr('aria-sidebar', 'closed')
            $('#new-main-nav-toggle').attr('aria-click', 'false')
            $('.cart-sidebar').removeClass('show')
        }

        let interval;

        function initSlickSearch() {
            const slickElement = document.querySelector('.search-result-row.force-slide');
            const slickProductElements = document.querySelectorAll('.search-panel .product-search-result');

            if (!slickElement) {
                console.log('slickElement not found yet.');
                return; // Exit if the element is not found
            }

            if (slickElement.getAttribute('data-listeners-attached')) {
                clearInterval(interval); // Stop interval
                console.log('Event listeners already attached.');
                return;
            }

            slickElement.setAttribute('data-listeners-attached', 'true');

            let isDragging = false;
            let startX;
            let scrollLeft;

            function handleDragStart(e) {
                isDragging = true;
                startX = e.pageX - slickElement.offsetLeft;
                scrollLeft = slickElement.scrollLeft;
                slickElement.style.cursor = 'grabbing';
            }

            function handleDragMove(e) {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.pageX - slickElement.offsetLeft;
                const walk = (x - startX) * 2; // Adjust scroll speed (2 is multiplier)
                slickElement.scrollLeft = scrollLeft - walk;
            }

            function handleDragEnd() {
                isDragging = false;
                slickElement.style.cursor = 'grab';
            }

            // Attach Drag Events to Container
            slickElement.addEventListener('mousedown', handleDragStart);
            slickElement.addEventListener('mousemove', handleDragMove);
            slickElement.addEventListener('mouseup', handleDragEnd);
            slickElement.addEventListener('mouseleave', handleDragEnd);

            // Attach Drag Events to Product Elements
            slickProductElements.forEach((productElement) => {
                productElement.addEventListener('mousedown', (e) => {
                    handleDragStart(e);
                    e.stopPropagation(); // Prevent conflict with container's `mousedown`
                });

                productElement.addEventListener('mousemove', (e) => {
                    handleDragMove(e);
                    e.stopPropagation(); // Prevent conflict with container's `mousemove`
                });

                productElement.addEventListener('mouseup', (e) => {
                    handleDragEnd(e);
                    e.stopPropagation(); // Prevent conflict with container's `mouseup`
                });
            });

            // Prevent Click Events During Dragging
            slickElement.addEventListener('click', (e) => {
                if (isDragging) {
                    e.preventDefault(); // Prevent click action if dragging occurred
                    e.stopPropagation(); // Stop event from propagating further
                    console.log('Click prevented due to drag.');
                }
            });

            slickProductElements.forEach((productElement) => {
                productElement.addEventListener('click', (e) => {
                    if (isDragging) {
                        e.preventDefault(); // Prevent click action if dragging occurred
                        e.stopPropagation(); // Stop event from propagating further
                        console.log('Click prevented on product due to drag.');
                    }
                });
            });

            // Clear the interval once slick is initialized
            clearInterval(interval);
            console.log('Slick initialized and interval cleared.');
        }

        // Check periodically until the element is found
        interval = setInterval(() => {
            initSlickSearch();           
        }, 100); // Check every 100ms

    })

    $(document).on('click', '#close-input-search', function (e) {
        e.preventDefault();
        $('html, body').css('overflow', '')
        $("body").removeClass("menu-opened")
        $('#close-container-drawer').attr('aria-sidebar', 'closed')
    })

    $('#close-container-drawer').click(function () {
        $('#close-input-search').trigger('click')
        $('html, body').css('overflow', '')
        $(this).attr('aria-sidebar', 'closed')
    })

    $('.filter-toggle').click(function () {
        // localStorage.setItem('show-filter', 'true');
        if ($('#close-container-drawer-filter').attr('aria-sidebar') == 'closed') {
            $('#close-container-drawer-filter').attr('aria-sidebar', 'opened')
        }
        if (window.matchMedia("(max-width: 750px)").matches) {
            $('body').addClass('has--popup-dropdown')
        }
    })

    // if (localStorage.getItem('show-filter') == 'true') {
    //     $('.filter-toggle').trigger('click')
    // }

    $('#close-container-drawer-filter').click(function () {
        $('.filter-toggle').trigger('click')
        $(this).attr('aria-sidebar', 'closed')
        localStorage.setItem('show-filter', 'false');
        if (window.matchMedia("(max-width: 750px)").matches) {
            $('body').removeClass('has--popup-dropdown')
        }

    })

    $('#cs-button').click(function () {
        $(this).addClass('active')
        $('#cs-container-dropdown').addClass('show--dropdown')
        $('#cs-container-overlay').addClass('active')

        $("body").addClass('menu-opened')
    })

    $('a.get-help--link').click(function (e) {
        e.preventDefault()
        $('#atmos-sidebar').attr('aria-sidebar', 'closed');
        $('#close-container-drawer').attr('aria-sidebar', 'closed');

        $('#cs-container-dropdown').addClass('show--dropdown')
        $('#cs-container-overlay').addClass('active')
        if (window.matchMedia("(max-width: 750px)").matches) {
            $('body').addClass('has--popup-dropdown')
        }
    })

    $('.back-to-sidebar--link').click(function (e) {
        e.preventDefault()
        $('#cs-container-dropdown').removeClass('show--dropdown')
        $('#atmos-sidebar').attr('aria-sidebar', 'opened')
    })

    $('.back-help--link').click(function (e) {
        e.preventDefault()
        $('#delivery-container-dropdown').removeClass('show--dropdown')
        $('#cs-container-dropdown').addClass('show--dropdown')
    })

    $('#btn-delivery-tracking').click(function () {
        $('#delivery-container-dropdown').addClass('show--dropdown')
        $('#cs-container-dropdown').removeClass('show--dropdown')
    })

    $('#cs-container-overlay').click(function () {
        $('#cs-container-overlay').removeClass('active')
        $('#cs-container-dropdown').removeClass('show--dropdown')
        $('#delivery-container-dropdown').removeClass('show--dropdown')
        $('#cs-button').removeClass('active')
        $('body').removeClass('has--popup-dropdown').removeClass('menu-opened')
    })

    $('#shopify-section-footer .column-nav .menu-title').click(function () {
        $(this).parent().toggleClass('active')
    })

    $('.sidebar-collapsible--link.has--child-menu').click(function (e) {
        e.preventDefault()
        $(this).parent().find('.sidebar-menu--nav.sidebar-secondary').toggleClass('active')
    })

    if ($('.featured-launch-product').length) {
        const $slider = $('.featured-launch-product .launch-product-list');
        console.log("upcoming", $slider.children().length)
        // Duplicate slides if fewer than required
        if ($slider.children().length == 4) {
            $slider.children().clone().appendTo($slider);
        }
        $('.featured-launch-product .launch-product-list').slick({
            autoplay: true,
            arrows: false,
            infinite: true,
            autoplaySpeed: 1000,
            slidesToShow: 4,
            slidesToScroll: 1,
            adaptiveHeight: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1120,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });

        if ($('#countdown-product-mobile').length) {
            let is_time = $('#countdown-product-mobile').attr('data-is-time')
            if (is_time == 'true') {

                let time_launch = $('#countdown-product-mobile').attr('data-release');
                let countDownDate = new Date(time_launch).getTime();

                let x = setInterval(function () {
                    let now = new Date().getTime();
                    let distance = countDownDate - now;
                    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    $('#countdown-product-mobile').find('span.day').html(days < 10 ? '0' + days : days);
                    $('#countdown-product-mobile').find('span.hour').html(hours < 10 ? '0' + hours : hours);
                    $('#countdown-product-mobile').find('span.minute').html(minutes < 10 ? '0' + minutes : minutes);
                    $('#countdown-product-mobile').find('span.second').html(seconds < 10 ? '0' + seconds : seconds);

                    if (distance < 0) {
                        $('countdown-product-mobile').hide()
                        clearInterval(x);
                    }
                }, 1000);
            }
        }

        $('.launch-product-item .countdown-product-launch').each(function (i, v) {
            let is_time = $(v).attr('data-is-time')
            if (is_time == 'true') {

                let time_launch = $(v).attr('data-release');
                let countDownDate = new Date(time_launch).getTime();

                let x = setInterval(function () {
                    let now = new Date().getTime();
                    let distance = countDownDate - now;
                    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    if (distance < 0) {
                        $('.featured-launch-product .launch-product-list').slick('unslick');

                        clearInterval(x);
                        // $(v).closest('.launch-product-item').remove();
                        const $slider = $('.featured-launch-product .launch-product-list');

                        // Duplicate slides if fewer than required
                        if ($slider.children().length == 4) {
                            $slider.children().clone().appendTo($slider);
                        }

                        var slider_upcoming = $('.featured-launch-product .launch-product-list').slick({
                            autoplay: true,
                            arrows: false,
                            infinite: true,
                            autoplaySpeed: 1000,
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            adaptiveHeight: true,
                            centerMode: false,
                            swipeToSlide: true,
                            responsive: [
                                {
                                    breakpoint: 1180,
                                    settings: {
                                        slidesToShow: 4,
                                    }
                                },
                                {
                                    breakpoint: 1120,
                                    settings: {
                                        slidesToShow: 2,
                                    }
                                }
                            ]
                        });

                        var scrollTimer;
                        $('.featured-launch-product .launch-product-list').on('wheel', function(event) {
                            const e_u = event.originalEvent;

                            // Hanya jalankan jika horizontal scroll dominan
                            if (Math.abs(e_u.deltaX) > Math.abs(e_u.deltaY)) {
                                event.preventDefault();

                                if (scrollTimer) return;
                                scrollTimer = setTimeout(() => {
                                    scrollTimer = null;
                                }, 300);

                                if (e_u.deltaX > 0) {
                                    slider_upcoming.slick('slickNext');
                                } else {
                                    slider_upcoming.slick('slickPrev');
                                }
                            }
                        });

                        $(v).closest('.launch-product-item .countdown-product-launch').html(`<span class="released-home released-upcase">Released</span>`)
                        // $(v).closest('.launch-product-item .countdown-product-launch').html(``)
                        return
                    }

                    $(v).closest('.launch-product-item').find('span.day').html(days < 10 ? '0' + days : days);
                    $(v).closest('.launch-product-item').find('span.hour').html(hours < 10 ? '0' + hours : hours);
                    $(v).closest('.launch-product-item').find('span.minute').html(minutes < 10 ? '0' + minutes : minutes);
                    $(v).closest('.launch-product-item').find('span.second').html(seconds < 10 ? '0' + seconds : seconds);
                }, 1000);
            }
        })
    }

    $('.sidebar-backto-primary').click(function () {
        $(this).closest('.sidebar-secondary').toggleClass('active')
    })

    if ($('article.product.collection-item').length) {
        let suggestion = [];

        // console.log($("[data-release]").length)
        if ($("[data-release]").length) {
            const countdownElements = document.querySelectorAll('[data-release]');
            countdownElements.forEach((element) => {
                const is_time = element.getAttribute('data-is-time')
                if (is_time == 'true') {
                    const releaseDate = new Date(element.getAttribute('data-release')).getTime();
                    const countdownInterval = setInterval(() => {
                        const now = new Date().getTime();
                        const timeLeft = releaseDate - now;

                        if (timeLeft < 0) {
                            clearInterval(countdownInterval);
                            element.innerHTML = 'Released';
                            if ($(".template-product").length > 0) {
                                setTimeout(() => {
                                    location.reload()
                                }, 1500);
                            }
                            return;
                        }

                        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                        const formattedDays = days < 10 ? "0" + days : days;
                        const formattedHours = hours < 10 ? "0" + hours : hours;
                        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
                        const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

                        element.innerHTML = `<span class="item-date"><time>${formattedDays}</time><info>d</info></span><span class="item-date"><time>${formattedHours}</time><info>h</info></span><span class="item-date"><time>${formattedMinutes}</time><info>m</info></span><span class="item-date"><time>${formattedSeconds}</time><info>s</info></span>`
                    }, 1000);
                }
                else {
                    let releaseText = element.getAttribute('data-release')
                    element.innerHTML = `<span class="item-releses-text">${releaseText}</span>`
                }
            })
        }

        // article.product.collection-item:not(.is-raffle)
        $(document).on('click', 'article.product.collection-item .product-featured-image, article.product.collection-item .product-title', function () {
            let product_handle = $(this).closest('article.product.collection-item').attr('data-handle')
            let product_summary = $(this).closest("article.product.collection-item").find(".summary").html();

            console.log(product_handle)

            if ($(this).closest('article.product.collection-item').hasClass('special-release')) {
                if($(this).closest('article.product.collection-item').hasClass('released')){
                    if ($('#quickbuy-modal').hasClass('show')) return;
                    render_content_quickbuy(product_handle, product_summary)
                }
                else{
                    render_content_special_release(product_handle)
                }
            }
            else {
                if ($('#quickbuy-modal').hasClass('show')) return;

                if($(this).hasClass("raffle")){
                    let raffle_status = $(this).closest(".product-featured-image").attr("raffle-status");
                    let raffle_start = $(this).closest(".product-featured-image").attr("raffle-start");
                    let raffle_end = $(this).closest(".product-featured-image").attr("raffle-end");

                    render_content_raffle(product_handle, product_summary, raffle_status, raffle_start, raffle_end)
                }
                else {
                    render_content_quickbuy(product_handle, product_summary)
                }
            }
        })

        async function fetchIndonesiaTime() {
            var indonesiaTimeUrl = 'https://worldtimeapi.org/api/timezone/Asia/Jakarta';
            try {
                const response = await fetch(indonesiaTimeUrl);
                const data = await response.json();
                // Mendapatkan waktu saat ini dari data yang diterima
                var waktuSekarang = new Date(data.datetime);
                return waktuSekarang;
            } catch (error) {
                console.error('Terjadi kesalahan:', error);
            }
        }

        function getNormalisedDatetime(dString) { // yyyy-mm-dd hh:mm:ss
            var parts = dString.split(" ");
            var dParts = parts[0].split("-");
            var tParts = parts[1].split(":");
            return new Date(dParts[0], dParts[1] - 1, dParts[2], tParts[0], tParts[1], tParts[2]);
        }

        function render_content_special_release(product_handle) {
            $.ajax({
                url: `/products/${product_handle}.js`,
                method: 'GET',
                dataType: 'json',
                beforeSend: function () {
                    suggestion = [];
                    $('#special-release-content').html('')
                },
                success: function (response) {
                    let product = response;

                    let vendor_handle = product.vendor.toLowerCase()

                    let special_release_price = product.variants[0].price.toString().slice(0, -2);
                    let special_release_compare_at_price = ''
                    if (product.variants[0].compare_at_price) {
                        special_release_compare_at_price = product.variants[0].compare_at_price.toString().slice(0, -2)
                    }
                    else {
                        special_release_compare_at_price = special_release_price
                    }

                    let special_release_main_image = `
                    <div class="special-release-main-image">
                        <img src="${product.images[0]}">
                    </div>
                    `

                    let special_release_gallery_item = ''
                    $.each(product.images, function (index, image) {
                        if (index == 0) {
                            return;
                        }

                        special_release_gallery_item += `
                        <div class="special-release-product-item">
                            <img src="${image}">
                        </div>
                        `
                    })

                    let special_release_product_price = ''
                    if (special_release_price != special_release_compare_at_price) {
                        special_release_product_price = `
                        <span class="price">IDR ${numberWithCommas(special_release_price)}</span>
                        <span class="price compare-price">IDR ${numberWithCommas(special_release_compare_at_price)}</span>
                        `
                    }
                    else {
                        special_release_product_price = `
                        <span class="price">IDR ${numberWithCommas(special_release_price)}</span>
                        `
                    }

                    let release_date = ''
                    let is_release_time = false

                    $.each(product.tags, function (i, tag) {
                        if (tag.includes('release-text-')) {
                            release_date = tag.split('release-text-')[1];
                            return;
                        }
                        else if (tag.includes('release-special-')) {
                            release_date = tag.split('release-special-')[1];
                            is_release_time = true;
                            return;
                        }
                        else if (tag.includes('release-')) {
                            release_date = tag.split('release-')[1];
                            is_release_time = true;
                            return;
                        }
                    })

                    if (release_date != "") {
                        if (is_release_time) {

                            let time_release = getNormalisedDatetime(release_date).getTime();
                            var today = new Date().getTime();
                            var timer = time_release - today;

                            if (timer > 0) {
                                release_button = setInterval(function () {
                                    today = new Date().getTime();
                                    timer = time_release - today;

                                    if (timer > 0) {
                                        var days = Math.floor(timer / (1000 * 60 * 60 * 24));
                                        var hours = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                        var minutes = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60));
                                        var seconds = Math.floor((timer % (1000 * 60)) / 1000);

                                        days = days.toString().length === 1 ? "0" + days : days;
                                        hours = hours.toString().length === 1 ? "0" + hours : hours;
                                        minutes = minutes.toString().length === 1 ? "0" + minutes : minutes;
                                        seconds = seconds.toString().length === 1 ? "0" + seconds : seconds;

                                        $(".release-button").html(`<span class="item-date"><time>${days}</time><info>d</info></span><span class="item-date"><time>${hours}</time><info>h</info></span><span class="item-date"><time>${minutes}</time><info>m</info></span><span class="item-date"><time>${seconds}</time><info>s</info></span>`)
                                    } else {
                                        clearInterval(release_button);
                                        location.reload();
                                    }
                                }, 1000);
                            }
                        }
                        else {
                            $(".release-button").html(`<span class="item-releses-text">${release_date}</span>`)
                        }
                    }

                    let special_release_content = `
                    <button type="button" class="btn-close" aria-label="Close">
                    <svg class="icon-sidebar-close" role="presentation" viewBox="0 0 16 14">
                        <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
                    </svg>
                    </button>
                    <div class="special-release-content-container">
                        <form action="" method="post" enctype="multipart/form-data" class="special-release-form" id="special-release-form">
                            <input type="hidden" name="product_id" value="${product.id}">
                            <div class="special-release-product-vendor medium-up--hide">
                                <a href="${window.location.origin}/collections/footwear1?filter.p.vendor=${product.vendor}" class="vendor">${product.vendor}</a>
                            </div>
                            <div class="special-release-product-title medium-up--hide">
                                <h4 class="title">${product.title}</h4>
                            </div>
                            <div class="special-release-product-price medium-up--hide">
                                ${special_release_product_price}
                            </div>
                            <div class="special-release-gallery">
                                ${special_release_main_image}
                                <div class="special-release-product-gallery" id="special-release-product-gallery">
                                    ${special_release_gallery_item}
                                </div>
                            </div>
                            <div class="special-release-product-title small--hide">
                                <h4 class="title">${product.title}</h4>
                            </div>
                            <div class="special-release-product-description">
                                <div class="description">${product.description}</div>
                            </div>
                            <div class="special-release-notified">
                                <button class="main-button release-button" type="button" disabled=""></button>
                                <button class="main-button notified-button" type="button">Get Notified</button>
                            </div>
                        </form>
                    </div>
                    `

                    $('#special-release-content').html(special_release_content)
                },
                error: function (xhr, status, error) {
                    console.error('Error fetching products:', error);
                    $('#products').html('<p>Sorry, there was an error loading the products.</p>');
                },
                complete: function () {
                    $('body').addClass('has--popup-dropdown')
                    $('#special-release-modal').addClass('show')
                }
            })
        }

        var release_button = null;
        function render_content_quickbuy(product_handle, product_summary = "") {
            location.href = `/products/${product_handle}`
            return
            // if (window.matchMedia("(min-width: 750px)").matches) {
            // }

            $.ajax({
                url: `/products/${product_handle}.js`,
                method: 'GET',
                dataType: 'json',
                beforeSend: function () {
                    suggestion = [];
                    $('#quickbuy-content').html('')
                },
                success: function (response) {
                    let product = response;
                    console.log('quick',product)
                    let vendor_handle = product.vendor.toLowerCase()

                    let quickbuy_price = product.variants[0].price.toString().slice(0, -2);
                    let quickbuy_compare_at_price = ''

                    if (product.variants[0].compare_at_price) {
                        quickbuy_compare_at_price = product.variants[0].compare_at_price.toString().slice(0, -2)
                    } else {
                        quickbuy_compare_at_price = quickbuy_price
                    }

                    let quickbuy_color = product.variants[0].option2
                    let quickbuy_first_sku = product.variants[0].sku
                    let quickbuy_check_available = product.variants[0].available

                    let product_name = product.title
                    let handle20 = product.title.substring(0, 20)

                    let quickbuy_gallery_item = ''
                    $.each(product.images, function (index, image) {
                        quickbuy_gallery_item += `
                        <div class="quickbuy-product-item">
                            <img src="${image}">
                        </div>
                        `
                    })

                    let product_tags = product.tags
                    let release = product_tags.some(tag => tag.includes("release-"));

                    let quickbuy_size_label_result = ''
                    let quickbuy_size = ''
                    let quickbuy_size_label = product.variants[0];
                    quickbuy_size_label = quickbuy_size_label.option1.split(' ');

                    if (typeof quickbuy_size_label[1] !== 'undefined') {
                        quickbuy_size_label_result = quickbuy_size_label[1].includes('Y')
                            ? quickbuy_size_label[0] + ' Youth'
                            : quickbuy_size_label[1] === 'W'
                                ? quickbuy_size_label[0] + ' Women'
                                : quickbuy_size_label[0];
                    }

                    $.each(product.variants, function (index, variant) {
                        let variant_option1_mobile = variant.option1.replaceAll(' ', '')
                        quickbuy_size += `
                        <div class="swatch-element swatch-size ${variant.available ? 'available' : 'soldout'} ${convertToSlug(variant.option1)} swatch-qb-${index}">
                            <input id="swatch-${index}-${convertToSlug(variant.option1)}" type="radio" name="option-0" value="${variant.id}" ${index == 0 ? 'checked' : ''} inventory="${variant.available ? 'enabled' : 'disabled'}" title="${product.title} - ${variant.title}" sku="${variant.sku}"/>
                            <label for="swatch-${index}-${convertToSlug(variant.option1)}">
                                ${variant.option1}
                            </label>
                        </div>
                        `
                    })

                    let quickbuy_product_price = ''
                    if (quickbuy_price != quickbuy_compare_at_price) {
                        quickbuy_product_price = `
                        <span class="price">IDR ${numberWithCommas(quickbuy_price)}</span>
                        <span class="price compare-price">IDR ${numberWithCommas(quickbuy_compare_at_price)}</span>
                        `
                    }
                    else {
                        quickbuy_product_price = `
                        <span class="price">IDR ${numberWithCommas(quickbuy_price)}</span>
                        `
                    }

                    let quickbuy_button = `<div class="quickbuy-buy-gift">
                        <button class="main-button buy-now-button" type="button" name="add-redirect-cart" id="cart-button" ${!quickbuy_check_available ? 'disabled' : ''}>
                            <span class="small--hide">Buy Now</span>
                            <span class="medium-up--hide">Express Buy</span>
                        </button>
                    </div>`;

                    // <button class="main-button buy-gift-button" type="button" name="add-redirect-gift" id="gift-button" ${!quickbuy_check_available ? 'disabled' : ''}>
                    //     <span>New! Buy As A Gift</span>
                    // </button>

                    let atc_button = `
                        <button class="main-button" type="button" name="add" id="add-to-cart-button" ${!quickbuy_check_available ? 'disabled' : ''}>${!quickbuy_check_available ? 'Add To Bag' : 'Add To Bag'}</button>
                    `;

                    let button_mobile = `
                    <div class="quickbuy-select-size-button medium-up--hide">
                        <button type="button" id="quickbuy-select-size-btn" class="quickbuy-select-size-btn">Select Size</button>
                    </div>
                    <div class="quickbuy-learn-more medium-up--hide">
                        <a href="${product.url}">Learn More</a>
                    </div>
                    `

                    let qty_button = `
                    <div class="quickbuy-qty">
                        <div class="quickbuy-qty-input">
                            <button class="qty-button qty-min" id="qty-min">
                                <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/minus-icon.svg?v=1726827191">
                            </button>
                            <input name="quantity" type="number" id="quantity-input" name="quantity" value="1" min="1" 
                                ${product.tags.includes('one-per-customer') ? 'max="1"' : ''}>
                            <button class="qty-button qty-plus" id="qty-plus">
                                <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/plus-icon.svg?v=1726827192">
                            </button>
                        </div>
                    </div>
                    `

                    let learn_more_cta = `
                    <div class="quickbuy-learn-more small--hide">
                        <a href="${product.url}">Learn More</a>
                    </div>
                    `

                    let clean_description = product.description.replace(/<\/?[^>]+(>|$)/g, "").trim()
                    let product_description = truncateWords(clean_description, 20)

                    let release_date = ''
                    let is_release_time = false

                    $.each(product.tags, function (i, tag) {
                        if (tag.includes('release-text-')) {
                            release_date = tag.split('release-text-')[1];
                            return;
                        }
                        else if (tag.includes('release-special-')) {
                            release_date = tag.split('release-special-')[1];
                            is_release_time = true;
                            return;
                        }
                        else if (tag.includes('release-')) {
                            release_date = tag.split('release-')[1];
                            is_release_time = true;
                            return;
                        }
                    })

                    if (release_date != "") {
                        if (is_release_time) {

                            let time_release = getNormalisedDatetime(release_date).getTime();
                            var today = new Date().getTime();
                            var timer = time_release - today;

                            if (timer > 0) {
                                release_button = setInterval(function () {
                                    today = new Date().getTime();
                                    timer = time_release - today;

                                    if (timer > 0) {
                                        var days = Math.floor(timer / (1000 * 60 * 60 * 24));
                                        var hours = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                        var minutes = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60));
                                        var seconds = Math.floor((timer % (1000 * 60)) / 1000);

                                        days = days.toString().length === 1 ? "0" + days : days;
                                        hours = hours.toString().length === 1 ? "0" + hours : hours;
                                        minutes = minutes.toString().length === 1 ? "0" + minutes : minutes;
                                        seconds = seconds.toString().length === 1 ? "0" + seconds : seconds;

                                        $(".release-button").html(`<span class="item-date"><time>${days}</time><info>d</info></span><span class="item-date"><time>${hours}</time><info>h</info></span><span class="item-date"><time>${minutes}</time><info>m</info></span><span class="item-date"><time>${seconds}</time><info>s</info></span>`)
                                    } else {
                                        clearInterval(release_button);
                                        location.reload();
                                    }
                                }, 1000);

                                quickbuy_button = `
                                    <div class="quickbuy-buy-gift small--hide">
                                        <button class="main-button release-button" type="button" disabled></button>
                                    </div>`
                                    ;

                                atc_button = `
                                    <button class="main-button notified-button" type="button">Get Notified</button>
                                `;

                                button_mobile = `
                                    <div class="quickbuy-select-size-button medium-up--hide">
                                        <button type="button" id="quickbuy-select-size-btn" class="quickbuy-select-size-btn">Select Size</button>
                                        <button class="main-button release-button" type="button" disabled></button>
                                    </div>
                                `

                                qty_button = `
                                <div class="quickbuy-qty small--hide">
                                    <div class="quickbuy-qty-input">
                                        <button class="qty-button qty-min" id="qty-min">
                                            <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/minus-icon.svg?v=1726827191">
                                        </button>
                                        <input name="quantity" type="number" id="quantity-input" name="quantity" value="1" min="1" 
                                            ${product.tags.includes('one-per-customer') ? 'max="1"' : ''}>
                                        <button class="qty-button qty-plus" id="qty-plus">
                                            <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/plus-icon.svg?v=1726827192">
                                        </button>
                                    </div>
                                </div>
                                `

                                learn_more_cta = `
                                <div class="quickbuy-learn-more small--hide">
                                    <a href="${product.url}">Learn More</a>
                                </div>
                                `
                            }
                        }
                        else {
                            quickbuy_button = `
                            <div class="quickbuy-buy-gift small--hide">
                                <button class="main-button release-button" type="button" disabled>
                                    <span class="item-releses-text">${release_date}</span>
                                </button>
                            </div>`;

                            atc_button = `
                                <button class="main-button notified-button" type="button">Get Notified</button>
                            `;

                            button_mobile = `
                                <div class="quickbuy-select-size-button medium-up--hide">
                                    <button type="button" id="quickbuy-select-size-btn" class="quickbuy-select-size-btn">Select Size</button>
                                    <button class="main-button release-button" type="button" disabled></button>
                                </div>
                            `

                            qty_button = `
                            <div class="quickbuy-qty small--hide">
                                <div class="quickbuy-qty-input">
                                    <button class="qty-button qty-min" id="qty-min">
                                        <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/minus-icon.svg?v=1726827191">
                                    </button>
                                    <input name="quantity" type="number" id="quantity-input" name="quantity" value="1" min="1" 
                                        ${product.tags.includes('one-per-customer') ? 'max="1"' : ''}>
                                    <button class="qty-button qty-plus" id="qty-plus">
                                        <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/plus-icon.svg?v=1726827192">
                                    </button>
                                </div>
                            </div>
                            `

                            learn_more_cta = `
                            <div class="quickbuy-learn-more small--hide">
                                <a href="${product.url}">Learn More</a>
                            </div>
                            `
                        }
                    }

                    let quickbuy_content = `
                    <button type="button" class="btn-close" aria-label="Close">
                    <svg class="icon-sidebar-close" role="presentation" viewBox="0 0 16 14">
                        <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
                    </svg>
                    </button>
                    <div class="quickbuy-content-left">
                        <div class="quickbuy-product-vendor medium-up--hide">
                            <a href="${window.location.origin}/collections/footwear1?filter.p.vendor=${product.vendor}" class="vendor">${product.vendor}</a>
                        </div>
                        <div class="quickbuy-product-title medium-up--hide">
                            <h4 class="title">${product.title}</h4>
                        </div>
                        <div class="quickbuy-product-price medium-up--hide">
                            ${quickbuy_product_price}
                        </div>
                        <div class="quickbuy-product-gallery small--hide" id="quickbuy-product-gallery">
                            ${quickbuy_gallery_item}
                        </div>
                        <div class="quickbuy-product-gallery-nav" id="quickbuy-product-gallery-nav">
                            ${quickbuy_gallery_item}
                        </div>
                        <div class="quickbuy-product-summary medium-up--hide">
                            <div class="description"><p>${product_summary}</p></div>
                        </div>
                        <div class="quickbuy-product-color-swatches medium-up--hide">
                            <div class="header">
                                <span class="swatches-label">Colour: <strong>${quickbuy_color}</strong></span>
                                <span class="swatches-label">SKU: <strong>${quickbuy_first_sku}</strong></span>
                            </div>
                            <div class="color-swatches"></div>
                        </div>
                        ${button_mobile}
                    </div>
                    <div class="quickbuy-content-right">
                        <form action="/cart/add" method="post" enctype="multipart/form-data" id="quickbuy-form" data-handle="${product.handle}" class="release-${release}">
                            <input type="hidden" name="product_id" id="product_id" value="${product.id}">
                            <div class="quickbuy-product-vendor small--hide">
                                <a href="${window.location.origin}/collections/footwear1?filter.p.vendor=${product.vendor}" class="vendor">${product.vendor}</a>
                            </div>
                            <div class="quickbuy-product-title small--hide">
                                <h4 class="title">${product.title}</h4>
                            </div>
                            <div class="quickbuy-product-price small--hide">
                                ${quickbuy_product_price}
                            </div>
                            <div class="quickbuy-product-summary small--hide">${product_summary}</div>
                            <div class="quickbuy-product-color-swatches small--hide">
                                <div class="header">
                                    <span class="swatches-label">Colour: <strong>${quickbuy_color}</strong></span>
                                    <span class="swatches-label label-sku">Product SKU: <strong>${quickbuy_first_sku}</strong></span>
                                </div>
                                <div class="color-swatches"></div>
                            </div>
                            <div class="quickbuy-product-size-swatches">
                                <div class="quickbuy-product-size-title medium-up--hide">
                                    <span class="title">Select your size</span>
                                </div>
                                <div class="header">
                                    <span class="swatches-label">Size: <b style="color: #01339E;">${quickbuy_size_label_result}</b></span>
                                    <a href="/products/${product.handle}#open-size-chart" class="swatches-size-chart">Size Chart</a>
                                </div>
                                <div class="size-swatches">
                                    ${quickbuy_size}
                                </div>
                            </div>
                            <div class="quickbuy-qty-button" id="quickbuy-qty-column">
                                ${qty_button}
                                <div class="quickbuy-cart-wishlist">
                                    ${atc_button}
                                    <span class="smartwishlist" data-product="${product.id}" data-variant="${product.variants[0].id}"></span>
                                </div>
                            </div>
                            ${quickbuy_button}
                            <div class="bdd-notify-v2-quick" style="display : none;">
                                <div class="box-notify">
                                    <button class="main-button" type="button" id="button-notify-quick">GET NOTIFIED</button>
                                </div>
                            </div>
                            ${learn_more_cta}
                        </form>
                    </div>
                    `

                    $('#quickbuy-content').html(quickbuy_content)
                    $('.swatch-qb-1 label').trigger("click")
                    $('.swatch-qb-0 label').trigger("click")
                    suggestion_color(product_name, product_handle, handle20)
                },
                error: function (xhr, status, error) {
                    console.error('Error fetching products:', error);
                    $('#products').html('<p>Sorry, there was an error loading the products.</p>');
                },
                complete: function () {
                    $('body').addClass('has--popup-dropdown')
                    $('#quickbuy-modal').addClass('show')
                    setTimeout(() => {
                        $('.quickbuy-modal.show .quickbuy-dialog-modal .quickbuy-content').css('transform', 'translateY(0)')
                    }, 300);

                    if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) {
                        ReloadSmartWishlist();
                    }

                    let key_slider_interval = setInterval(() => {
                        if ($('#quickbuy-product-gallery.slick-slider').length) {
                            clearInterval(key_slider_interval)
                        }
                        else {
                            $('#quickbuy-product-gallery').slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: false,
                                fade: true,
                                asNavFor: '.quickbuy-product-gallery-nav'
                            });
                            $('#quickbuy-product-gallery-nav').slick({
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                asNavFor: '.quickbuy-product-gallery',
                                arrows: false,
                                dots: false,
                                centerMode: false,
                                focusOnSelect: true,
                                responsive: [
                                    {
                                        breakpoint: 750,
                                        settings: {
                                            slidesToShow: 2,
                                            slidesToScroll: 1,
                                            centerMode: false,
                                        }
                                    },
                                ]
                            });
                        }
                    }, 0);
                }
            })
        }

        function render_content_raffle(product_handle, product_summary = "", raffle_status = "", raffle_start, raffle_end) {
            $.ajax({
                url: `/products/${product_handle}.js`,
                method: 'GET',
                dataType: 'json',
                beforeSend: function () {
                    suggestion = [];
                    $('#quickbuy-content').html('')
                },
                success: function (response) {
                    let product = response;
                    let vendor_handle = product.vendor.toLowerCase()

                    let quickbuy_price = product.variants[0].price.toString().slice(0, -2);
                    let quickbuy_compare_at_price = ''

                    if (product.variants[0].compare_at_price) {
                        quickbuy_compare_at_price = product.variants[0].compare_at_price.toString().slice(0, -2)
                    } else {
                        quickbuy_compare_at_price = quickbuy_price
                    }

                    let quickbuy_color = product.variants[0].option2
                    let quickbuy_first_sku = product.variants[0].sku
                    let quickbuy_check_available = product.variants[0].available

                    let product_name = product.title
                    let handle20 = product.title.substring(0, 20)

                    let quickbuy_gallery_item = ''
                    $.each(product.images, function (index, image) {
                        quickbuy_gallery_item += `
                        <div class="quickbuy-product-item">
                            <img src="${image}">
                        </div>
                        `
                    })

                    let product_tags = product.tags
                    let release = product_tags.some(tag => tag.includes("release-"));

                    let quickbuy_size_label_result = ''
                    let quickbuy_size = ''
                    let quickbuy_size_label = product.variants[0];
                    quickbuy_size_label = quickbuy_size_label.option1.split(' ');

                    if (typeof quickbuy_size_label[1] !== 'undefined') {
                        quickbuy_size_label_result = quickbuy_size_label[1].includes('Y')
                            ? quickbuy_size_label[0] + ' Youth'
                            : quickbuy_size_label[1] === 'W'
                                ? quickbuy_size_label[0] + ' Women'
                                : quickbuy_size_label[0];
                    }

                    let quickbuy_product_price = ''
                    if (quickbuy_price != quickbuy_compare_at_price) {
                        quickbuy_product_price = `
                        <span class="price">IDR ${numberWithCommas(quickbuy_price)}</span>
                        <span class="price compare-price">IDR ${numberWithCommas(quickbuy_compare_at_price)}</span>
                        `
                    }
                    else {
                        quickbuy_product_price = `
                        <span class="price">IDR ${numberWithCommas(quickbuy_price)}</span>
                        `
                    }

                    let clean_description = product.description.replace(/<\/?[^>]+(>|$)/g, "").trim()
                    let product_description = truncateWords(clean_description, 20)

                    let release_date = ''
                    let is_release_time = false

                    $.each(product.tags, function (i, tag) {
                        if (tag.includes('release-text-')) {
                            release_date = tag.split('release-text-')[1];
                            return;
                        }
                        else if (tag.includes('release-special-')) {
                            release_date = tag.split('release-special-')[1];
                            is_release_time = true;
                            return;
                        }
                        else if (tag.includes('release-')) {
                            release_date = tag.split('release-')[1];
                            is_release_time = true;
                            return;
                        }
                    })

                    let button_raffle = ""
                    let raffle_info = "";
                    // raffle_status = "on-going"
                    if(raffle_status == "closed"){
                        button_raffle = `
                            <button type="button" disabled="disabled" class="main-button buy-gift-button">Raffle Closed</button>
                        `;

                        raffle_info = `
                            <span class="raffle-info">Raffle Closed</span>
                        `;
                    }
                    else {
                        button_raffle = `
                            <a href="/products/${product_handle}" class="main-button buy-now-button">Join Raffle</a>
                        `;

                        raffle_info = `
                            <span class="raffle-info">Raffle On Going - <span class="raffle-info-timer"></span></span>
                        `;
                    }

                    let quickbuy_content = `
                    <button type="button" class="btn-close" aria-label="Close">
                    <svg class="icon-sidebar-close" role="presentation" viewBox="0 0 16 14">
                        <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
                    </svg>
                    </button>
                    <div class="quickbuy-content-left">
                        <div class="quickbuy-product-vendor medium-up--hide">
                            <a href="${window.location.origin}/collections/footwear1?filter.p.vendor=${product.vendor}" class="vendor">${product.vendor}</a>
                        </div>
                        <div class="quickbuy-product-title medium-up--hide">
                            <h4 class="title">${product.title}</h4>
                        </div>
                        <div class="quickbuy-product-price medium-up--hide">
                            ${quickbuy_product_price}
                            <span class="divider"></span>
                            ${raffle_info}
                        </div>
                        <div class="quickbuy-product-gallery small--hide" id="quickbuy-product-gallery">
                            ${quickbuy_gallery_item}
                        </div>
                        <div class="quickbuy-product-gallery-nav" id="quickbuy-product-gallery-nav">
                            ${quickbuy_gallery_item}
                        </div>
                        <div class="quickbuy-product-summary medium-up--hide">
                            <div class="description"><p>${product_summary}</p></div>
                        </div>
                        <div class="content-in-button medium-up--hide">
                            ${button_raffle}
                        </div>
                    </div>
                    <div class="quickbuy-content-right">
                        <div class="content-top-button">
                            <input type="hidden" name="product_id" id="product_id" value="${product.id}">
                            <div class="quickbuy-product-vendor small--hide">
                                <a href="${window.location.origin}/collections/footwear1?filter.p.vendor=${product.vendor}" class="vendor">${product.vendor}</a>
                            </div>
                            <div class="quickbuy-product-title small--hide">
                                <h4 class="title">${product.title}</h4>
                            </div>
                            <div class="quickbuy-product-price small--hide">
                                ${quickbuy_product_price}
                                <span class="divider"></span>
                                ${raffle_info}
                            </div>
                            <div class="quickbuy-product-summary small--hide">${product_summary}</div>
                        </div>
                        <div class="content-in-button">
                            ${button_raffle}
                        </div>
                    </div>
                    `

                    $('#quickbuy-content').html(quickbuy_content).addClass("quickbuy-raffle")
                    $('.swatch-qb-1 label').trigger("click")
                    $('.swatch-qb-0 label').trigger("click")
                    suggestion_color(product_name, product_handle, handle20)


                    raffle_start = new Date(raffle_start.replace(" ", "T"));
                    raffle_end = new Date(raffle_end.replace(" ", "T"));
                    const timerInterval = setInterval(function () {
                        const now = new Date().getTime();
                        if (now < raffle_start) {
                            // Waktu sekarang sebelum raffle dimulai
                            const distance = raffle_start - now;
                            updateTimer(distance, "Starts In ");
                        } else if (now >= raffle_start && now < raffle_end) {
                            // Raffle sedang berlangsung
                            const distance = raffle_end - now;
                            updateTimer(distance, "Ends In ");
                        } else {
                            clearInterval(timerInterval);
                            // document.getElementById("timer").innerHTML = "Raffle has ended!";
                        }
                    }, 1000);
                },
                error: function (xhr, status, error) {
                    console.error('Error fetching products:', error);
                    $('#products').html('<p>Sorry, there was an error loading the products.</p>');
                },
                complete: function () {
                    $('body').addClass('has--popup-dropdown')
                    $('#quickbuy-modal').addClass('show')
                    setTimeout(() => {
                        $('.quickbuy-modal.show .quickbuy-dialog-modal .quickbuy-content').css('transform', 'translateY(0)')
                    }, 300);

                    if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) {
                        ReloadSmartWishlist();
                    }

                    let key_slider_interval = setInterval(() => {
                        if ($('#quickbuy-product-gallery.slick-slider').length) {
                            clearInterval(key_slider_interval)
                        }
                        else {
                            $('#quickbuy-product-gallery').slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: false,
                                fade: true,
                                asNavFor: '.quickbuy-product-gallery-nav'
                            });
                            $('#quickbuy-product-gallery-nav').slick({
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                asNavFor: '.quickbuy-product-gallery',
                                arrows: false,
                                dots: false,
                                centerMode: false,
                                focusOnSelect: true,
                                responsive: [
                                    {
                                        breakpoint: 750,
                                        settings: {
                                            slidesToShow: 2,
                                            slidesToScroll: 1,
                                            centerMode: false,
                                        }
                                    },
                                ]
                            });
                        }
                    }, 0);
                }
            })
        }

        function updateTimer(distance, label) {
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
            // Zero-padding
            // let paddedDays = days.toString().padStart(2, "0");
            let paddedDays = days == "00" ? "" : days + "d";

            const paddedHours = hours.toString().padStart(2, "0");
            const paddedMinutes = minutes.toString().padStart(2, "0");
            const paddedSeconds = seconds.toString().padStart(2, "0");
        
            $(".raffle-info-timer").html(`${label} ${paddedDays} ${paddedHours}:${paddedMinutes}:${paddedSeconds}`)
        }

        function add_product(data) {
            if (suggestion.length == 0) {
                suggestion.push(data);
            } else {
                var data_is_exist = '';
                for (let i = 0; i < suggestion.length; i++) {
                    if (suggestion[i]['handle'] == data['handle']) {
                        var data_is_exist = [i];
                    } else {
                        var data_is_exist = null;
                    }
                }
                if (data_is_exist == null) {
                    suggestion.push(data);
                }
            }
        }

        function suggestion_color(product_name, product_handle, handle20) {
            // execute all function with ajax
            $.ajax({
                type: "GET",
                async: false,
                url: window.Shopify.routes.root + "search/suggest.json?q=" + handle20 + "&resources[type]=product&resources[options][unavailable_products]=hide&limit=10&resources[options][fields]=title",
                success: function (suggestions) {
                    const productSuggestions = suggestions.resources.results.products;
                    for (let i = 0; i < productSuggestions.length; i++) {
                        if (productSuggestions[i]['title'] == product_name) {
                            if (productSuggestions[i]['tags'].indexOf('raffle') === -1) {
                                add_product(productSuggestions[i])
                            }
                        }
                    }
                },
                error: function (response) {
                    console.log(response)
                }
            });

            // print all result to html format
            for (let l = 0; l < suggestion.length; l++) {
                if (suggestion[l]['handle'] == product_handle) {
                    $('#quickbuy-content .color-swatches').append(
                        `
                    <div class="color-swatch-item current-color-swatch-item">
                      <div class="result-swatch-item" data-handle="#">
                        <div class="swatch-img">
                          <img src="${suggestion[l]['image']}">  
                        </div>
                      </div>  
                    </div>
                    `
                    )
                } else {
                    $('#quickbuy-content .color-swatches').append(
                        `
                    <div class="color-swatch-item">
                      <div class="result-swatch-item" data-handle="${suggestion[l]['handle']}">
                        <div class="swatch-img">
                          <img src="${suggestion[l]['image']}">  
                        </div>
                      </div>  
                    </div>
                    `
                    )
                }
            }
        }

        $(document).on('click', '#quickbuy-content .quickbuy-product-size-swatches .size-swatches .swatch-element label', function (e) {
            let quickbuy_product_handle = $('#quickbuy-content #quickbuy-form').attr('data-handle')
            let quickbuy_inventory = $(this).prev().attr('inventory')
            let quickbuy_variant = $(this).prev().val()
            let quickbuy_title = $(this).prev().attr('title')
            let quickbuy_sku = $(this).prev().attr('sku')

            $('.notify-v2-popup__content .product-name').html(toCapitalize(quickbuy_title));
        	$('.notify-v2-popup__content #product_name').val(quickbuy_title);
            $('.notify-v2-popup__content #variant_id').val(quickbuy_variant);
            $('.notify-v2-popup__content #product_sku').val(quickbuy_sku);

            $.ajax({
                type: 'GET',
                url: `/products/${quickbuy_product_handle}.js`,
                dataType: 'json',
                success: function (product) {
                    product.variants.forEach(variant => {
                        if (quickbuy_variant == variant.id) {
                            $('#quickbuy-content .quickbuy-product-color-swatches .label-sku').html(`Product SKU: <strong>${variant.sku}</strong>`)
                        }
                    });
                },
                error: function (error) {
                    console.error(error)
                }
            })

            if (quickbuy_inventory != 'disabled') {
                $('#quickbuy-content #cart-button, #quickbuy-content #gift-button, #quickbuy-content #add-to-cart-button').removeAttr('disabled')
                $('#quickbuy-content #add-to-cart-button').text('Add To Bag')

                $(".quickbuy-buy-gift").show();
                $(".bdd-notify-v2-quick").hide();

                $(".new-qty").removeClass('soldout');
                $("#quantity-input").attr('disabled', true);
            } else {
                $('#quickbuy-content #cart-button, #quickbuy-content #gift-button, #quickbuy-content #add-to-cart-button').attr('disabled', 'disabled')
                $('#quickbuy-content #add-to-cart-button').text('Add To Bag')
                
                $(".quickbuy-buy-gift").hide();
                $(".bdd-notify-v2-quick").show();

                $(".new-qty").addClass('soldout');
                $("#quantity-input").removeAttr('disabled');
            }
        })

        $(document).on('click', '#quickbuy-content .btn-close', function () {
            $(this).closest('#quickbuy-content').removeClass('mobile-collapse-active')
            $('body').removeClass('has--popup-dropdown')
            $('#quickbuy-modal').removeClass('show')
            $('#quickbuy-content').css('transform', '')

            // matikan interal
            clearInterval(release_button)
            release_button = null
        })

        $('#quickbuy-modal').click(function (e) {
            if (e.target !== this)
                return;

            $('body').removeClass('has--popup-dropdown')
            $(this).removeClass('show')

            clearInterval(release_button)
            release_button = null
        })

        $(document).on('click', '#special-release-content .btn-close', function () {
            $(this).closest('#quickbuy-content').removeClass('mobile-collapse-active')
            $('body').removeClass('has--popup-dropdown')
            $('#special-release-modal').removeClass('show')

            // matikan interal
            clearInterval(release_button)
            release_button = null
        })

        $('#special-release-modal').click(function (e) {
            if (e.target !== this)
                return;

            $('body').removeClass('has--popup-dropdown')
            $(this).removeClass('show')

            clearInterval(release_button)
            release_button = null
        })

        $(document).on('click', '#quickbuy-content .color-swatch-item .result-swatch-item', function () {
            let product_handle = $(this).attr('data-handle')
            if (product_handle != '#') {
                clearInterval(release_button)
                release_button = null

                render_content_quickbuy(product_handle)
            }
        })

        $(document).on('click', '#quickbuy-qty-column .quickbuy-qty-input .qty-min', function (e) {
            e.preventDefault()
            let input = $('#quickbuy-content').find('#quantity-input')
            let qty = parseInt($(input).val())
            if (qty == 1) {
                qty = 1
            }
            else {
                qty -= 1
            }

            $(input).val(qty)
        })

        $(document).on('click', '#quickbuy-qty-column .quickbuy-qty-input .qty-plus', function (e) {
            e.preventDefault()
            let input = $('#quickbuy-content').find('#quantity-input')
            let qty = parseInt($(input).val())
            qty += 1

            $(input).val(qty)
        })

        $(document).on('click', '#quickbuy-select-size-btn', function (e) {
            e.preventDefault()
            $(this).closest('#quickbuy-content').toggleClass('mobile-collapse-active')
        })

        function addToCartDrawer() {
            let cart_section_drawer_str = '<section id="cart-panel-custom" class="cart-panel panel hide-transition"><div class="cart"><div class="row"><div class="small-8 columns small-push-2"><h3 class="panel-title">Cart</h3></div><div class="small-2 columns text-right"><button type="button" class="close-button"><i class="fa fa-times"></i></button></div></div><div class="scroll-container"><div class="row"><div class="small-12 columns" id="product-line-items"></div></div></div><div class="footer-container"><div class="row columns"><div id="total-line-items"><div class="cart-total"></div><a href="/checkout" id="checkout-button" class="main-button">Checkout</a></div><button type="button" class="secondary-button continue-shop">Continue shopping</button></div></div></div></section>';

            let product_line_item_str = '<article class="product-line-item"><div class="row"><div class="small-4 medium-3 columns"><img src="" class="product-image" alt=""></div><div class="small-8 medium-9 columns"><h4 class="product-title"></h4><div class="product-price"></div></div></div><div class="row"><div class="small-12 medium-12 columns"><div class="product-size"></div></div><div class="small-4 medium-6 columns"><div class="product-quantity"><div class="quantity-button reduce text-left"><button type="button"><i class="fa fa-minus-circle fa-sm"></i></button></div><div class="quantity-button quantity text-center"></div><div class="quantity-button add text-right"><button type="button"><i class="fa fa-plus-circle fa-sm"></i></button></div></div></div></div></article>';

            let cart_section_drawer = jQuery(cart_section_drawer_str);
            let product_line_item = jQuery(product_line_item_str);
            let total = 0;

            jQuery.ajax({
                type: 'GET',
                url: '/cart.js',
                cache: false,
                dataType: 'json',
                success: function (cart) {
                    jQuery.each(cart.items, function (i, v) {
                        // console.log(v);

                        let temp = product_line_item.clone();
                        let final_price = '' + v.final_price;
                        final_price = final_price.substring(0, final_price.length - 2);
                        final_price = final_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                        temp.find('img.product-image').prop('src', v.featured_image.url);
                        temp.find('img.product-image').prop('alt', v.title);
                        temp.find('h4.product-title').html(v.title);
                        temp.find('.product-price').html('IDR ' + final_price);
                        temp.find('.product-size').html(v.options_with_values[0].value + ' / ' + v.options_with_values[1].value);
                        temp.find('.quantity-button.quantity').html(v.quantity);
                        total += v.final_price;

                        jQuery(cart_section_drawer).find('#product-line-items').append(temp);

                        // console.log(temp);
                    });
                },
                complete: function (cart) {
                    let final_total = '' + total;
                    final_total = final_total.substring(0, final_total.length - 2);
                    final_total = final_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    cart_section_drawer.find('.cart-total').html('IDR ' + final_total);
                    jQuery('body').append(cart_section_drawer);

                    setTimeout(function () {
                        jQuery('#cart-panel-custom').removeClass('hide-transition');
                        jQuery('#cart-panel-custom').addClass('active');
                        // refreshIndicator();

                        setTimeout(function () {
                            jQuery('#cart-panel-custom').removeClass('active');
                            jQuery('#cart-panel-custom').addClass('hide-transition');

                            setTimeout(function () {
                                jQuery('#cart-panel-custom').remove();
                            }, 1000);
                        }, 2000);
                    }, 1000);
                }
            });

            setTimeout(function () {
                document
                    .getElementsByClassName("cart-panel")[0]
                    .classList.remove("active");
                document
                    .getElementsByClassName("cart-panel")[0]
                    .classList.add("hide-transition");
                //alert('tes32')
            }, 5000);
        }

        if (!$('body').hasClass('template-product')) {
            $(document).on('click', '#quickbuy-content #add-to-cart-button', function (e) {
                e.preventDefault()
                let form = $(this).closest('#quickbuy-form')
                let variant_id = ''
                let qty = form.find('#quantity-input').val()

                form.find('input[name="option-0"]:checked').each(function (i, v) {
                    variant_id += $(v).val()
                })

                let data = {
                    id: variant_id,
                    quantity: qty,
                };
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: data,
                    dataType: "json",
                    success: function () {
                        let cart_quantity_indicator = $('#cart-quantity-indicator').html()
                        if (cart_quantity_indicator == "") {
                            $('#cart-quantity-indicator').show()
                            cart_quantity_indicator = "0"
                        }
                        cart_quantity_indicator = parseInt(cart_quantity_indicator) + 1
                        $('#cart-quantity-indicator').html(cart_quantity_indicator)

                        $('body').removeClass('has--popup-dropdown')
                        $('#quickbuy-modal').removeClass('show')

                        $('#quickbuy-content .btn-close').trigger('click')
                        $('#notif-atc-modal').addClass('show')
                        // addToCartDrawer()
                    },
                    error: function (responses) {
                        let error = responses.responseJSON;
                        // console.log(responses, responses.responseJSON);
                        alert(error.message)
                    },
                });
            })
        } else {
            $(document).on('click', '#quickbuy-content #add-to-cart-button', function (e) {
                e.preventDefault()
                let form = $('.in-product-page')
                let variant_id = ''
                let qty = form.find('#quantity-input').val()

                form.find('input[name="option-0"]:checked').each(function (i, v) {
                    variant_id += $(v).attr('data-variant-id')
                })

                let data = {
                    id: variant_id,
                    quantity: qty,
                };
                // console.log(data)
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: data,
                    dataType: "json",
                    success: function () {
                        let cart_quantity_indicator = $('#cart-quantity-indicator').html()
                        if (cart_quantity_indicator == "") {
                            $('#cart-quantity-indicator').show()
                            cart_quantity_indicator = "0"
                        }
                        cart_quantity_indicator = parseInt(cart_quantity_indicator) + 1
                        $('#cart-quantity-indicator').html(cart_quantity_indicator)

                        $('#quickbuy-content .btn-close').trigger('click')
                        $('#notif-atc-modal').addClass('show')

                        $('#append-back-product').append($('.product-swatch:not(.cart-select-product-swatch), .product-qty, .product-button, .product-notify'));
                        $('#select-size').show();
                        // addToCartDrawer()
                    },
                    error: function (responses) {
                        console.log(responses);
                    },
                });
            })
        }

        $(document).on('click', '#quickbuy-content #cart-button', function (e) {
            e.preventDefault()
            let form = $(this).closest('#quickbuy-form')
            let variant_id = ''
            let qty = form.find('#quantity-input').val()

            form.find('input[name="option-0"]:checked').each(function (i, v) {
                variant_id += $(v).val()
            })

            let data = {
                id: variant_id,
                quantity: qty,
            };

            window.location.href = `/cart/${variant_id}:${qty}`;

            // $.ajax({
            //     type: "POST",
            //     url: "/cart/add.js",
            //     data: data,
            //     dataType: "json",
            //     success: function () {
            //         setTimeout(function () {
            //             window.location.href = "/cart";
            //         }, 2000);
            //     },
            //     error: function (responses) {
            //         console.log(responses);
            //     },
            // });
        })

        $(document).on('click', '#quickbuy-content #gift-button', function (e) {
            e.preventDefault()
            let form = $(this).closest('#quickbuy-form')
            let variant_id = ''
            let qty = form.find('#quantity-input').val()

            form.find('input[name="option-0"]:checked').each(function (i, v) {
                variant_id += $(v).val()
            })

            let data = {
                id: variant_id,
                quantity: qty,
                properties: { '_description': 'product gift' }
            };
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: data,
                dataType: "json",
                success: function () {
                    setTimeout(function () {
                        window.location.href = "/cart";
                    }, 2000);
                },
                error: function (responses) {
                    console.log(responses);
                },
            });
        })
    }

    const $navSlider = $('.product-image-slide-nav');
    const $mainSlider = $('.product-image-slide');
    const totalSlides = $navSlider.find('img').length;
    const totalMainSlides = $mainSlider.find('img').length;

    // Function to initialize the main slider
    const initializeMainSlider = () => {
        $mainSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            fade: true,
            asNavFor: '.product-image-slide-nav'
        });
    };

    // Function to initialize the navigation slider
    const initializeNavSlider = () => {
        $navSlider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: true,
            dots: false,
            focusOnSelect: true,
            verticalSwiping: false,
            arrows: false,
            asNavFor: '.product-image-slide',
            infinite: true
        });
    };

    // Initialize both sliders initially
    initializeMainSlider();
    initializeNavSlider();

    // Clone slides if fewer than slidesToShow
    if (totalSlides <= 4) {
        const $slides = $navSlider.find('.slick-slide');
        const clonesNeeded = 8 - totalSlides;

        for (let i = 0; i < clonesNeeded; i++) {
            const $clone = $slides.eq(i % totalSlides).clone(); // Clone from index 0
            $navSlider.slick('slickAdd', $clone);
        }
    }

    if (totalMainSlides <= 4) {
        const $slides = $mainSlider.find('.slick-slide');
        const clonesNeeded = 8 - totalMainSlides;

        for (let i = 0; i < clonesNeeded; i++) {
            const $clone = $slides.eq(i % totalMainSlides).clone(); // Clone from index 0
            $mainSlider.slick('slickAdd', $clone);
        }
    }

    // Destroy and reinitialize both sliders to reflect changes
    $mainSlider.slick('unslick');
    $navSlider.slick('unslick');

    // Reinitialize sliders
    initializeMainSlider();
    initializeNavSlider();

    // Reinitialize position
    $(window).on('load', function () {
        $mainSlider.slick('setPosition');
        $navSlider.slick('setPosition');

        get_customer = $('#get_personal_customer').length;

        if (get_customer) {
            let cus_id = $('#get_personal_customer').attr('data-id');
            let jsonData = {
                id: cus_id,
                url_shopify: 'atmos-indonesia.myshopify.com'
            }
            var url = "https://atmos-custom-plugin-front.devbdd.com/api/customers/get_data";
            
            $.ajax({
                type: "POST",
                url: url,
                data: jsonData,
                dataType: "json",
                success: function (responses) {
                    $('#FirstName').val(responses.firstName);
                    $('#LastName').val(responses.lastName);
                    $('#Email').val(responses.email);
                    if (responses.gender) {
                        let gender = responses.gender.toLowerCase(); // Ensure lowercase for consistency
                        $("select[name='gender']").val(gender); // Set value in gender select
                    }

                    if (responses.phone) {
                        let phone = responses.phone;
                        let countryCode = "62"; // Default country code
                        
                        if (phone.startsWith("62")) {
                            phone = phone.substring(2); // Remove "62"
                        } else if (phone.startsWith("0")) {
                            phone = phone.substring(1); // Remove leading "0"
                        } else {
                            countryCode = ""; // Keep phone as is if no "62" or "0"
                        }
            
                        $("input[name='country_code']").val(countryCode);
                        $("input[name='phone']").val(phone);
                    }

                    if (responses.bod) {
                        let [year, month, day] = responses.bod.split("-"); // Split YYYY-MM-DD
            
                        $("select[name='day']").val(day.padStart(2, '0')); // Ensure 2-digit format
                        $("select[name='month']").val(month.padStart(2, '0')); 
                        $("select[name='year']").val(year);
                    }
                    
                    if (responses.shoe_size) {
                        $("#shoes_size").val(responses.shoe_size);
                    }
                    
                    
                },
                error: function (responses) {
                    console.log(responses);
                },
            });
        }
    });
    
    $('.line-item-properties-input textarea').each(function (i) {
        let lineitem_label = $(this).closest('.line-item-product').find('.line-item-properties-label span')
        lineitem_label.text("(" + this.value.length + "/300)")
        $(this).on('input', function () {
            var len = this.value.length;
            if (len > 300) {
                this.value = this.value.substring(0, 300); // Trim if needed
            }
            if (len >= 300) {
                lineitem_label.text("(300/300)"); // Update the counter
            } else {
                lineitem_label.text("(" + len + "/300)"); // Update the counter
            }
        });
    });

    if ($('body').hasClass('template-cart')) {
        $('.line-item-quantity a.button').click(function (e) {
            if ($(this).attr('href').trim() == '#') {
                e.preventDefault()

                let line_index = $(this).closest('.line-item-quantity').attr('data-line-index')
                let quantity = $(this).closest('.line-item-quantity').find('.line-item-quantity-value').html()
                let notifHtml = `
                <div class="line-item-notif line-index-${line_index}">
                    Product quantity is not more than ${quantity}
                </div>`

                $(this).closest('.line-item-quantity').before(notifHtml)
                setTimeout(function () {
                    $(`.line-item-notif.line-index-${line_index}`).remove()
                    // console.log('line-item-notif removed')
                }, 3000)
            }
        })

        if (window.matchMedia("(max-width: 750px)").matches) {
            $('.template-cart .featured-collection-container .featured-product .slick-product-container .collection-title').html("ATMOS' PICK")
        }
    }

    if ($(".main-text-running").length) {
        const text_running = new Swiper(".main-text-running", {
            loop: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            freeMode: true,
            speed: 5000,
            slidesPerView: 'auto',
            spaceBetween: 0,
        });
    }

    if ($('.section-brands-all').length) {
        $('.section-brands-all .brands-vendor-item a').each(function(){
            let img = $(this).attr('data-img')
            let href = $(this).attr('href')
            if(img.includes("/")){
                $('#brands-image').css({ 'background-image': `url("${img}")` })
                return false;
            }
        })

        $('.section-brands-all .brands-vendor-item a').on("mouseover", function () {
            let img = $(this).attr('data-img')
            let href = $(this).attr('href')
            if (img != '#') {
                // let html_anchor = `<a href="${href}">SHOP NOW</a>`
                $('#brands-image').css({ 'background-image': `url("${img}")` })
                // $('#brands-image').html(html_anchor)
            }
        });

        $('.brands-letter-item-bold').click(function (e) {
            e.preventDefault()

            let letter = $(this).html().trim().toLowerCase()
            $('.section-brands-all .brands-vendor-item').each(function (i, v) {
                let letter_brand = $(v).attr('data-brand-letter')
                if (letter_brand == letter) {
                    $(v).show()
                }
                else {
                    $(v).hide()
                }
            })
        })
    }

    if ($('.section-about-content').length) {
        if (window.matchMedia("(max-width: 750px)").matches) {
            $('.section-about-content .about-content-title .title br').remove()
        }
    }

    if ($('.section-about-brands').length) {
        const about_brands_list = new Swiper(".about-brands-list", {
            loop: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            freeMode: true,
            speed: 5000,
            // slidesPerView: 'auto',
            slidesPerView: 8,
            spaceBetween: 0,
            breakpoints: {
                0: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 8
                }
            }        
        });
        about_brands_list();
    }

    if ($('.section-about-connection').length) {
        if (window.matchMedia("(max-width: 750px)").matches) {
            $('.section-about-connection .connection-header-title .title br').remove()
        }
    }

    $('#sort-by-title').click(function () {
        $(this).toggleClass('active');
        $(this).siblings('.sort-by-content').toggleClass('active');
    })

    function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    if ($('#section-faq-delivery').length) {
        $('#section-faq-delivery .faq-delivery-item-inner').click(function () {
            $('#faq-delivery-content').html('')
            $('body').addClass('has--popup-dropdown')

            let json_id = $(this).attr('data-id')
            let data = JSON.parse($(`#${json_id}`).html())
            // console.log('data_faq', data)

            if (data.title === "") {
                return;
            }

            let accordion_item = ''
            for (let i = 1; i <= 8; i++) {
                if (data['question_' + i] === "") continue;

                accordion_item += `
                <div class="at-item">
                    <div class="at-title">
                        <h2>${data['question_' + i]}</h2>
                    </div>
                    <div class="at-tab">
                        ${htmlDecode(data['answer_' + i])}
                    </div>
                </div>
                `
            }

            let faq_title = ''
            if (data.title_mobile != "") {
                faq_title = `
                <h4 class="title small--hide">${data.title}</h4>
                <h4 class="title medium-up--hide">${data.title_mobile}</h4>
                `
            }
            else {
                faq_title = `<h4 class="title">${data.title}</h4>`
            }

            let html = `
            <button type="button" class="btn-close small--hide" aria-label="Close">
				<svg class="icon-sidebar-close" role="presentation" viewBox="0 0 16 14">
					<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
				</svg>
			</button>
            <div class="faq-modal-container">
                <div class="faq-modal-title">
                    <button class="faq-modal-title-button medium-up--hide">
                        <i class="las la-arrow-left"></i>
                    </button>
                    ${faq_title}
                </div>
                <div class="faq-modal-accordion">
                    <div class="accordion" id="accordion-faq-modal">
                        ${accordion_item}
                    </div>
                </div>
            </div>
            <div class="faq-modal-footer medium-up--hide">
                <footer class="site-footer footer-drawer-2024">
                    <div class="row">
                        <div class="small-12 columns columns-copyright-payment">
                            <div class="row row-copyright-social">
                                <div class="medium-12 columns columns-social">
                                <div class="social-logos">
                                    <div class="social-logo social-logo-instagram">
                                    <a href="https://www.instagram.com/atmos_id" target="_blank">
                                        <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/iconmonstr-instagram-11.svg?v=1725434462" alt="social-logo-instagram">
                                    </a>
                                    </div>
                                    <div class="social-logo social-logo-tiktok">
                                    <a href="https://www.tiktok.com/@atmos_id" target="_blank">
                                        <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/logo-tiktok-svgrepo-com.svg?v=1725434462" alt="social-logo-tiktok">
                                    </a>
                                    </div>
                                    <div class="social-logo social-logo-youtube">
                                    <a href="https://www.youtube.com/channel/UCYQtYkv9X6-4y5SvWSNboiQ" target="_blank">
                                        <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/iconmonstr-youtube-6.svg?v=1725434463" alt="social-logo-youtube">
                                    </a>
                                    </div>
                                    <div class="site-credits">
                                    &copy; atmos Indonesia. All Rights Reserved.
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="image-pktn medium-up--hide">
                                <img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/ditjen.webp?v=1740645392" width="" height="">
                            </div>
                            </div>
                    </div>
                </footer>
            </div>
            `

            $('#faq-delivery-content').html(html)
            $('#faq-delivery-modal').addClass('show')
            $('#faq-delivery-modal #faq-delivery-content').addClass('active')
        })
    }

    if ($('#faq-delivery-modal').length) {
        $(document).on('click', '#faq-delivery-content .btn-close', function () {
            $('body').removeClass('has--popup-dropdown')
            setTimeout(() => {
                $('#faq-delivery-modal').removeClass('show')
            }, 100);
        })

        $('#faq-delivery-modal').click(function (e) {
            if (e.target !== this)
                return;

            $('body').removeClass('has--popup-dropdown')
            $(this).removeClass('show')
        })

        $(document).on('click', '.at-title', function () {
            $(this)
                .toggleClass("active")
                .next(".at-tab")
                .slideToggle()
                .parent()
                .siblings()
                .find(".at-tab")
                .slideUp()
                .prev()
                .removeClass("active");
        });

        $(document).on('click', '.faq-modal-title-button', function () {
            $('#faq-delivery-content').removeClass('active')
            setTimeout(() => {
                $('#faq-delivery-content .btn-close').trigger('click')
            }, 500)
        })
    }

    if ($('#section-lookbook-detail').length) {
        $('#section-lookbook-detail .lookbook-detail-item').click(function () {
            $('#lookbook-detail-content').html('')

            let collection_handle = $(this).attr('data-collection-handle')
            let collection_image = $(this).attr('data-collection-image')

            $.ajax({
                type: "GET",
                url: `/collections/${collection_handle}/products.json`,
                dataType: "json",
                success: function (responses) {
                    let products = responses.products
                    let lookbook_description = $('#lookbook-description').html()

                    let products_html = ''
                    $.each(products, function (i, product) {
                        // console.log('product', product)
                        let vendor_handle = product.vendor.toLowerCase()

                        let price = product.variants[0].price.toString().slice(0, -3)
                        let compare_at_price = ''
                        if (product.variants[0].compare_at_price) {
                            compare_at_price = product.variants[0].compare_at_price.toString().slice(0, -3)
                        }
                        else {
                            compare_at_price = price
                        }

                        let price_html = ''
                        if (price != compare_at_price) {
                            price_html = `
                            <div class="price">
                                IDR ${numberWithCommas(price)}
                            </div>
                            <div class="price compare-price">
                                IDR ${numberWithCommas(compare_at_price)}
                            </div>
                            `
                        }
                        else {
                            price_html = `
                            <div class="price">
                                IDR ${numberWithCommas(price)}
                            </div>
                            `
                        }

                        let size_html = ''
                        $.each(product.variants, function (i2, variant) {
                            size_html += `
                            <div class="lookbook-size-item swatch-element swatch-size ${variant.available ? 'available' : 'soldout'} ${convertToSlug(variant.option1)}">
                                <input id="swatch-${i2}-${convertToSlug(variant.option1)}" type="radio" name="option-0" value="${variant.id}" inventory="${variant.available ? 'enabled' : 'disabled'}" ${variant.available ? 'enabled' : 'disabled'} />
                                <label for="swatch-${i2}-${convertToSlug(variant.option1)}">
                                    ${variant.option1}
                                </label>
                            </div>
                            `
                        })

                        products_html += `
                        <div class="lookbook-product-item">
                            <div class="lookbook-product-image">
                                <div class="lookbook-product-image-inner">
                                    <img src="${product.images[0].src}" alt="${product.title}" class="small--hide">
                                    <a href="/products/${product.handle}" class="medium-up--hide">
                                        <img src="${product.images[0].src}" alt="${product.title}">
                                    </a>
                                </div>
                            </div>
                            <div class="lookbook-product-detail">
                                <div class="lookbook-product-brand">
                                    <a href="/collections/footwear1?filter.p.vendor=${vendor_handle}" class="title-brand">
                                        ${product.vendor}
                                    </a>
                                </div>
                                <div class="lookbook-product-title">
                                    <a href="/products/${product.handle}" class="title-product">
                                        ${product.title}
                                    </a>
                                </div>
                                <div class="lookbook-product-price">
                                    ${price_html}
                                </div>
                                <div class="lookbook-product-button small--hide">
                                    <div class="lookbook-button-size">
                                        <button class="btn-lookbook-size">Select Size</button>
                                        <div class="lookbook-button-atc">
                                            <button class="btn-lookbook-atc" style="display: none;">ADD TO Bag</button>
                                        </div>
                                    </div>
                                    <div class="lookbook-button-wishlist">
                                        <span class="smartwishlist" data-product="${product.id}" data-variant="${product.variants[0].id}"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="lookbook-product-size">
                                <div class="lookbook-size-title">
                                    <div class="title">Select your size</div>
                                </div>
                                <div class="lookbook-size-list">
                                    ${size_html}
                                </div>
                            </div>
                        </div>
                        `
                    })

                    let content_html = `
                    <button type="button" class="btn-close" aria-label="Close">
                        <svg class="icon-sidebar-close small--hide" role="presentation" viewBox="0 0 16 14">
                            <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
                        </svg>
                        <svg class="icon-sidebar-close medium-up--hide" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 10L0 9L4 5L0 1L1 0L5 4L9 0L10 1L6 5L10 9L9 10L5 6L1 10Z" fill="white"/>
                        </svg>
                    </button>
                    <div class="lookbook-content-container">
                        <div class="lookbook-content-image">
                            <img src="${collection_image}" alt="lookbook-content-image">
                        </div>
                        <div class="lookbook-content-product">
                            <div class="lookbook-content-title">
                                <div class="title">Shop The Look</div>
                            </div>
                            <div class="lookbook-content-description small--hide">
                                <div class="description">${lookbook_description}</div>
                            </div>
                            <div class="lookbook-product-list">
                                ${products_html}
                            </div>
                        </div>
                    </div>
                    `

                    $('#lookbook-detail-content').html(content_html)
                },
                error: function (responses) {
                    console.log(responses);
                },
                complete: function () {
                    if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) {
                        ReloadSmartWishlist();
                    }

                    $('body').addClass('has--popup-dropdown')
                    $('#lookbook-detail-modal').addClass('show')
                }
            });
        })
    }

    if ($('#lookbook-detail-modal').length) {
        $(document).on('click', '#lookbook-detail-content .btn-close', function () {
            $('body').removeClass('has--popup-dropdown')
            $('#lookbook-detail-modal').removeClass('show')
        })

        $('#lookbook-detail-modal').click(function (e) {
            if (e.target !== this)
                return;

            $('body').removeClass('has--popup-dropdown')
            $(this).removeClass('show')
        })
        
        $(document).on('click', '#lookbook-detail-content .lookbook-size-item label', function () {
            $(this).closest('.lookbook-product-item').find('.lookbook-button-atc .btn-lookbook-atc').show()
            $(this).closest('.lookbook-product-item').find('.lookbook-button-size .btn-lookbook-size').hide()
        })

        $(document).on('click', '#lookbook-detail-content .btn-lookbook-size', function () {
            $(this).closest('.lookbook-product-item').find('.lookbook-product-size').toggleClass('active')
        })

        $(document).on('click', '#lookbook-detail-content .btn-lookbook-atc', function () {
            let product_size = $(this).closest('.lookbook-product-item').find('.lookbook-product-size')
            let variant_id = ''
            product_size.find('input[name="option-0"]:checked').each(function (i, v) {
                variant_id += $(v).val()
            })

            if ($(product_size).hasClass('active') && variant_id != '') {
                let data = {
                    id: variant_id,
                    quantity: 1,
                };
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: data,
                    dataType: "json",
                    success: function () {
                        let cart_quantity_indicator = $('#cart-quantity-indicator').html()
                        if (cart_quantity_indicator == "") {
                            $('#cart-quantity-indicator').show()
                            cart_quantity_indicator = "0"
                        }
                        cart_quantity_indicator = parseInt(cart_quantity_indicator) + 1
                        $('#cart-quantity-indicator').html(cart_quantity_indicator)

                        $('#notif-atc-modal').addClass('show')

                    },
                    error: function (responses) {
                        console.log(responses);
                    },
                });
            }
            else {
                $(product_size).addClass('active')
            }
        })

        SWCallbackExpressWishlistCollectionItemAdded = function (wishlistItem) {
            notif(1, 'Item has been added to wishlist')
        };

        SWCallbackExpressWishlistCollectionItemRemoved = function (wishlistItem) {
            notif(1, 'Item has been removed from wishlist')
        }

        SWCallbackCustomerWishlistCollectionItemAdded = function (wishlistItem) {
            notif(1, 'Item has been added to wishlist')
        };

        SWCallbackCustomerWishlistCollectionItemRemoved = function (wishlistItem) {
            notif(1, 'Item has been removed from wishlist')
        }
    }

    let modal_remove_cart = $('#remove-cart-modal')
    let modal_remove_cart_content = $('#remove-cart-content')
    $('.line-item-qty-operation-delete-cta').click(function (e) {
        e.preventDefault()
        let line_index = $(this).attr('data-line-index')
        let product_id = $(this).attr('data-product-id')
        let variant_id = $(this).attr('data-variant-id')
        let handle = $(this).attr('data-handle')
        $.ajax({
            type: 'GET',
            url: `/products/${$(this).attr('data-handle')}.js`,
            dataType: 'json',
            cache: false,
            success: function (product, status, xhr) {
                modal_remove_cart.toggleClass('show')
                modal_remove_cart_content.append(`
                    <div class="row flex" id="product-remove-container">
                        <div class="medium-4">
                            <div class="product-remove-image">
                                <img src="${product.featured_image}" alt="product-remove-image">
                            </div>
                        </div>
                        <div class="medium-8">
                            <div class="product-remove-detail">
                                <div id="remove_modal_title">Remove from Cart?</div>
                                <div class="remove-modal-description">Save it to your wishlist to keep it for later.</div>
                                <div class="product-remove-button">
                                    <button data-line-index="${line_index}" class="btn-remove-cart">No, thanks</button>
                                    <button data-line-index="${line_index}" data-product-id="${product_id}" data-variant-id="${variant_id}" data-handle="${handle}" class="btn-add-to-wishlist">Add to Wishlist</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    `)
                },
            error: function (response) {
                console.log(response)
            }
        })
    })

    modal_remove_cart.find('.btn-close').click(function (e) {
        e.preventDefault()
        modal_remove_cart.removeClass('show')
        $('#product-remove-container').remove()
    })

    $(document).on('click', '.btn-remove-cart', function (e) {
        e.preventDefault()
        let line_index = $(this).attr('data-line-index')
        notif(1, 'Item has been removed from cart');
        setTimeout(() => {
            window.location.href = `/cart/change?line=${line_index}&quantity=0`;
        }, 2000);
    })

    $(document).on('click', '.btn-add-to-wishlist', function (e) {
        e.preventDefault()
        let line_index = $(this).attr('data-line-index')
        let product_id = $(this).attr('data-product-id')
        let variant_id = $(this).attr('data-variant-id')
        AddToSmartWishlist(product_id, variant_id);
        notif(1, 'Item has been added to wishlist');
        setTimeout(() => {
            window.location.href = `/cart/change?line=${line_index}&quantity=0`;
        }, 2000);

    })

    if ($('body').hasClass('template-collection')) {
        $(document).on('click', '.main-button.notified-button', function () {
            if ($('#customer-data-notify').length == 0) {
                window.location.href = '/account'
                return;
            }

            let customer = $('#customer-data-notify').html()
            customer = JSON.parse(customer)
            let product_id = $('#quickbuy-form').find('#product_id').val()

            let url = 'https://atmos-custom-plugin-front.devbdd.com/api/customers/submit'
            let jsonData = {
                "url_shopify": Shopify.shop,
                "id_form": 2,
                "ktp": 0,
                "receipt_number": 0,
                "product": product_id,
                "name": customer.name,
                "email": customer.email,
                "phone": customer.phone,
                "ig": null,
                "shoe_size": null,
                "address": null,
                "birtday": null
            }

            $.ajax({
                type: "POST",
                url: url,
                data: jsonData,
                dataType: "json",
                success: function (result) {
                    if(result.response.status == "200"){
                        notif(1, "Your request has been submitted")
                    }
                    else {
                        notif(2, "You have submitted previously")
                    }

                    $('#quickbuy-content .btn-close').trigger('click')
                },
                error: function (responses) {
                    console.log(responses);
                },
            });
        })

        // $(document).on("click", ".template-collection .product.grid-item", function () {
        //     const collectionHandle = window.location.pathname;
        //     const productHandle = $(this).data("handle");
        
        //     sessionStorage.setItem("restore-collection-handle", collectionHandle);
        //     sessionStorage.setItem("restore-product-handle", productHandle);
        // });        

        // document.addEventListener('DOMContentLoaded', function () {
        //     const navEntries = performance.getEntriesByType("navigation");
        //     const isBack = navEntries.length && navEntries[0].type === "back_forward";
        //     const fromProductPage = document.referrer.includes("/products/");

        //     if (isBack) {
        //         const currentPath = window.location.pathname;
        //         const savedCollection = sessionStorage.getItem("restore-collection-handle");
        //         const savedProduct = sessionStorage.getItem("restore-product-handle");

        //         if (!savedCollection || !savedProduct || currentPath !== savedCollection) return;
            
        //         let maxLoadAttempts = 10;
        //         let loadAttempts = 0;
            
        //         const tryFindAndScroll = () => {
        //             const $target = $(`.product.grid-item[data-handle="${savedProduct}"]`);
        //             console.log("cari", $target.length)
        //             if ($target.length > 0) {
        //                 const offsetTop = $target.offset().top;
        //                 window.scrollTo({
        //                     top: offsetTop
        //                 });
                        
        //                 sessionStorage.removeItem("restore-collection-handle");
        //                 sessionStorage.removeItem("restore-product-handle");
        //             } else {
        //                 const $loadMoreBtn = $("#AjaxinatePagination a");
            
        //                 if ($loadMoreBtn.length > 0 && loadAttempts < maxLoadAttempts) {
        //                     $loadMoreBtn[0].click();
        //                     loadAttempts++;
                            
        //                     setTimeout(tryFindAndScroll, 1000);
        //                 } else {
        //                     sessionStorage.removeItem("restore-collection-handle");
        //                     sessionStorage.removeItem("restore-product-handle");
        //                 }
        //             }
        //         };

        //         setTimeout(tryFindAndScroll, 0);
        //     }     
        // });
    }
    else if($('body').hasClass('template-collection') == false && $('body').hasClass('template-product') == false) {
        $(document).on('click', '.main-button.notified-button', function () {
            if ($('#customer-data-notify').length == 0) {
                window.location.href = '/account'
                return;
            }
    
            let customer = $('#customer-data-notify').html()
            customer = JSON.parse(customer)
            let product_id = $('#quickbuy-form').find('#product_id').val()
    
            let url = 'https://atmos-custom-plugin-front.devbdd.com/api/customers/submit'
            let jsonData = {
                "url_shopify": Shopify.shop,
                "id_form": 2,
                "ktp": 0,
                "receipt_number": 0,
                "product": product_id,
                "name": customer.name,
                "email": customer.email,
                "phone": customer.phone,
                "ig": null,
                "shoe_size": null,
                "address": null,
                "birtday": null
            }
    
            $.ajax({
                type: "POST",
                url: url,
                data: jsonData,
                dataType: "json",
                success: function (result) {
                    if(result.response.status == "200"){
                        notif(1, "Your request has been submitted")
                    }
                    else {
                        notif(2, "You have submitted previously")
                    }

                    $('#quickbuy-content .btn-close').trigger('click')
                },
                error: function (responses) {
                    console.log(responses);
                },
            });
        })
    }


    if($(".template-register").length < 1){
        $(".personal-information-form").on("submit", function(e) {
            e.preventDefault(); // Prevent page reload
        
            // Convert form data to JSON
            var formDataArray = $(this).serializeArray();
            var jsonData = {};
        
            $.each(formDataArray, function () {
                jsonData[this.name] = this.value;
            });
        
            //console.log("JSON Data:", jsonData); // Debugging
        
            $.ajax({
                url: "https://atmos-custom-plugin-front.devbdd.com/api/customers/update_data",
                type: "POST",
                data: JSON.stringify(jsonData), // Send as JSON string
                contentType: "application/json", // Tell server it's JSON
                dataType: "json", // Expect JSON response
                success: function(response) {
                    if (response.status === "success") {
                        // Create success label
                        $(".main-button").before('<div class="success-message" style="color: green; margin-bottom: 10px;">Form submitted successfully!</div>');
                        
                        // Wait 3 seconds and refresh
                        setTimeout(function() {
                            location.reload();
                        }, 3000);
                    }
                },
                error: function(xhr, status, error) {
                    alert("Submission failed! Please try again.");
                    console.error(xhr.responseText);
                }
            });
        });
    }
    
    // if ($('body').hasClass('template-wishlist')) {
    //     $('#section-id-footer-product-slider').hide()
    // }

    if ($('body').hasClass('template-product')) {
        $(document).on('click', '.main-button.notified-button', function (e) {
            e.preventDefault()

            if ($('#customer-data-notify').length == 0) {
                window.location.href = '/account'
                return;
            }

            let customer = $('#customer-data-notify').html()
            customer = JSON.parse(customer)
            let product = $('#product-data').html()
            product = JSON.parse(product)

            let url = 'https://atmos-custom-plugin-front.devbdd.com/api/customers/submit'
            let jsonData = {
                "url_shopify": Shopify.shop,
                "id_form": 2,
                "ktp": 0,
                "receipt_number": 0,
                "product": product.id,
                "name": customer.name,
                "email": customer.email,
                "phone": customer.phone,
                "ig": null,
                "shoe_size": null,
                "address": null,
                "birtday": null
            }

            $.ajax({
                type: "POST",
                url: url,
                data: jsonData,
                dataType: "json",
                success: function (result) {
                    if(result.response.status == "200"){
                        notif(1, "Your request has been submitted")
                    }
                    else {
                        notif(2, "You have submitted previously")
                    }
                },
                error: function (responses) {
                    console.log(responses);
                },
            });
        })

        let current_url = location.href
        if (current_url.includes('open-size-chart')) {
            setTimeout(() => {
                $(".toggle-size-chart").trigger("click")
            }, 1000);
        }

        function updateCountdown() {
            let now = new Date();
            let hours = now.getHours();
            let minutes = now.getMinutes();
            let seconds = now.getSeconds();
            
            let startTime = 6; // 6 AM
            let shippedTime = 12;    // 12 AM
            let endTime = 17;    // 5 PM
            
            if (hours >= startTime && hours < shippedTime) {                
                // Hitung selisih waktu
                let totalCurrentSeconds = hours * 3600 + minutes * 60 + seconds;
                let totalTargetSeconds = shippedTime * 3600;
                let difference = totalTargetSeconds - totalCurrentSeconds;
                
                if (difference > 0) {
                    $('.estimate-information-available').show();
                    $('.estimate-information-shipped').hide();
                    $('.estimate-information-disable').hide();
                }
            }
            else if (hours >= shippedTime && hours < endTime) {                
                // Hitung selisih waktu
                let totalCurrentSeconds = hours * 3600 + minutes * 60 + seconds;
                let totalTargetSeconds = endTime * 3600;
                let difference = totalTargetSeconds - totalCurrentSeconds;
                
                if (difference > 0) {
                    $('.estimate-information-available').hide();
                    $('.estimate-information-shipped').show();
                    $('.estimate-information-disable').hide();
                }
            } 
            else {
                $('.estimate-information-available').hide();
                $('.estimate-information-shipped').hide();
                $('.estimate-information-disable').show();
            }
        }
        
        // Jalankan pertama kali
        updateCountdown();
        
        // Update setiap detik
        setInterval(updateCountdown, 1000);
    }

    if ($('.section-collection-features').length) {
        let params = new URLSearchParams(window.location.search);
        let filter_group = params.get('filter_group');

        if (filter_group) {
            $('.collection-features-item').each(function (i, v) {
                let handle = $(v).attr('data-handle')

                if (filter_group == handle) {
                    $(`.collection-recomendation-item[data-handle="${handle}"]`).addClass('active')
                    let href = $(`.collection-recomendation-item[data-handle="${handle}"]`).find('a').attr('href')
                    href = href.replace(`?filter_group=${handle}`, "");
                    $(`.collection-recomendation-item[data-handle="${handle}"]`).find('a').attr('href', href)

                    $(v).show()
                }
                else {
                    $(`.collection-recomendation-item[data-handle="${handle}"]`).removeClass('active')
                    $(v).hide()
                }
            })
        }
    }

    if ($('#form-cart-page').length) {
        $('#form-cart-page').submit(function (e) {
            // e.preventDefault()

            // console.log('serialize array', $(this).serializeArray())
        })
    }

    if ($('body').hasClass('template-features')) {
        if (window.matchMedia("(max-width: 750px)").matches) {
            $('.collection-features-recommendation .collection-recomendation-item.collection-recomendation-title .title').click(function () {
                $(this).closest('.collection-features-header.collection-container-features').addClass('active')

                $(this).closest('.collection-features-header.collection-container-features').animate({
                    scrollLeft: $(this).closest('.collection-features-header.collection-container-features').outerWidth()
                }, 500);

                $(this).closest('.collection-features-header.collection-container-features').removeClass('active')
            })
        }
    }

    if($(".raffle-image-list").length){
        $(".raffle-image-list").slick({
            autoplay: false,
            arrows: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    if($("#countdown-launch-status").length){
        if (window.matchMedia("(max-width: 750px)").matches) {
            $(document).ready(function() {
                function updateCountdown() {
                    var endTimeStr = $('#countdown-launch-status').data('launch');
                    var endTime = new Date(endTimeStr.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var timeLeft = endTime - now;
            
                    if (timeLeft > 0) {
                        var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                        var hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
                        var minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
                        var seconds = Math.floor((timeLeft / 1000) % 60);
    
                
                        $('#countdown-launch-status').html(`Released in
                            <span class="countdown-item" id="countdown-days">${days.toString().padStart(2, '0')}d</span>
                            <div class="countdown-divider">:</div>
                            <span class="countdown-item" id="countdown-hours">${hours.toString().padStart(2, '0')}h</span>
                            <div class="countdown-divider">:</div>
                            <span class="countdown-item" id="countdown-minutes">${minutes.toString().padStart(2, '0')}m</span>
                            <div class="countdown-divider">:</div>
                            <span class="countdown-item" id="countdown-seconds">${seconds.toString().padStart(2, '0')}s</span>    
                        `);
                    } else {
                        $('#countdown-launch-status').html('Released');
                        clearInterval(countdownInterval);
                    }
                }
            
                updateCountdown();
                var countdownInterval = setInterval(updateCountdown, 1000);
            });
        }
    }

    if($(".register-form").length){
        if (window.matchMedia("(max-width: 750px)").matches) {
            $(".title-shoesize").append($(".form-group.shoe-size, .form-group.custom-select.title-form"))
            $(".form-group.phone-input select option:first-child").html("Indonesia (+62)")
        }
        else {
            $(".form-group.custom-select.title-form select option:first-child").remove()
        }
    }

    if($(".template-login").length){
        $(".toggle-reset-password-button").click(function(){
            $("#customer_login, .forgot-password-link").hide();
            $("#recover-customer-password, .login-back-box").show();
        })

        $(".back-to-login-link").click(function(){
            $("#customer_login, .forgot-password-link").show();
            $("#recover-customer-password, .login-back-box").hide();
        })
    }
})(jQuery);
